import React, { useState, createContext } from 'react';
//import { resolve } from 'dns';
const axios = require('axios')
const { API_URL } = require('../MetaData/Metadata')


// Exporting Context
export const StudentContext = createContext();

const StudentContextProvider = (props) => {

    const defaultGeneralDetails = {
        department: {
            _id: null,
            shift: null,
            department: null
        },
        nme_subject: {
            department_handling: {
                _id: null,
                shift: null,
                department: null,
            },
            _id: null,
            subject_code: null,
            name: null,
        },
        _id: null,
        register_no: null,
        name: null,
        dob: null,
        language: null,
        university_code: null,
    }

    const [student, setStudent] = useState(defaultGeneralDetails);
    const [isSessionExpired,setIsSessionExpired] = useState(true);

    // Get general information
    const getGeneralDetails = async () => {
        try {
            const apiRoute = `${API_URL}/student/general`;
            const xAuthToken = localStorage.getItem('token');
            const loginRequest = await axios({
                method: 'post',
                url: apiRoute,
                headers: { 'x-auth-token': xAuthToken },
            })
            const response = await loginRequest.data;
            setStudent(response)
            setIsSessionExpired(false);
        } catch (error) {
            setIsSessionExpired(true);
            console.error(error);
        }
    }

    const resetStudent = () => {
        setStudent(defaultGeneralDetails);
    }

    return (
        <StudentContext.Provider value={{ getGeneralDetails, student, resetStudent, isSessionExpired}}>
            {props.children}
        </StudentContext.Provider>
    );
}

export default StudentContextProvider;